import React from 'react';
import { MapPin, Users, FileText } from 'lucide-react';


export default function Cemetery() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="text-white py-16" style={{ background: 'linear-gradient(to right, #001f3f, #001f3f)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <h1 className="text-5xl md:text-6xl font-bold mb-4">Qabrastan Details</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        {/* Qabrastan Section */}
        <div className="mb-16">
          <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-10 hover:shadow-lg transition-all">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              
              {/* NEW QABRASTAN */}
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <MapPin className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-2">
                      Qabrastan - Westward Corner of Masjid Complex
                    </h3>
                    <p className="font-poppins text-gray-700">341 Dunhams Corner Rd</p>
                    <p className="font-poppins text-gray-700">East Brunswick, NJ 08816</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Users className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-2">
                      Qabrastan Points of Contact
                    </h3>

                    <div className="space-y-2">
                      <div>
                        <p className="font-poppins text-gray-700">Mohammed bhai Tapia</p>
                        <a
                          href="tel:8487022620"
                          className="font-poppins text-dawoodi-gold font-semibold hover:underline"
                        >
                          +1 (848) 702-2620
                        </a>
                      </div>

                      <div>
                        <p className="font-poppins text-gray-700">Shaikh Idris Bhai Diwan</p>
                        <a
                          href="tel:9179689303"
                          className="font-poppins text-dawoodi-gold font-semibold hover:underline"
                        >
                          +1 (917) 968-9303
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* OLD QABRASTAN */}
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <MapPin className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-2">
                      Qabrastan - Jersey State Memorial Park - Pre December 2025
                    </h3>
                    <p className="font-poppins text-gray-700">13 Conover Road</p>
                    <p className="font-poppins text-gray-700">Millstone, New Jersey 08535</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

                    <div className="mb-16 flex justify-center">
                      <div className="bg-gradient-to-br from-dawoodi-navy to-dawoodi-navy text-white rounded-2xl p-8 max-w-lg text-center hover:shadow-2xl transition-all">
                        <div className="text-6xl mb-6">📄</div>
                        <h3 className="font-playfair text-2xl font-bold mb-4">Guzarnar Bio-Data Form</h3>
                        <a
                          href="https://drive.google.com/uc?export=download&id=1DlobTDu5GkLWkF7XkUqrB9-CGIQXJSiu"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center space-x-2 bg-dawoodi-gold text-dawoodi-navy font-bold px-8 py-4 rounded-xl hover:bg-yellow-300 transition-colors"
                        >
                          <FileText className="w-5 h-5" />
                          <span>Access Form</span>
                        </a>
                      </div>
                    </div>

      </div>
    </div>
  );
}